export const FETCH_LOCATIONS_REQUEST =
    'FETCH_LOCATIONS_REQUEST';
export const FETCH_LOCATIONS_SUCCESS =
    'FETCH_LOCATIONS_SUCCESS';
export const FETCH_LOCATIONS_FAILURE =
    'FETCH_LOCATIONS_FAILURE';